import { useMemo } from 'react';

import { useCurrentPage } from '@/components/Page';
import { useSchemaForUniqueId } from '@/hooks/discovery/appliedSchema';
import { useValidatedParams } from '@/hooks/params';

const OVERVIEW = 'overview';

type SchemaFilter = [databaseName: string, schemaName?: string] | undefined;

export const useSelectedSchemaFilter = (): SchemaFilter => {
  const { currentPage } = useCurrentPage();
  const { schemaName, databaseName, dbtUniqueId } = useValidatedParams();

  const currentResource = useSchemaForUniqueId(dbtUniqueId);
  const targetDatabase = databaseName || currentResource?.database;
  const targetSchema = schemaName || currentResource?.schema;

  return useMemo(() => {
    if (currentPage === 'projectOverview') {
      return [OVERVIEW];
    }
    if (
      currentPage === 'resourceFilter' ||
      currentPage === 'multiProject' ||
      currentPage === 'searchResults' ||
      currentPage === 'selectResults'
    ) {
      return undefined;
    }
    if (!targetDatabase || !targetSchema) return undefined;
    return [targetDatabase, targetSchema];
  }, [currentPage, targetDatabase, targetSchema]);
};
